import { useEffect, useState } from "react";
import api from "@/lib/api";

// Renders an image fetched from a protected endpoint (Bearer) as an object URL.
export default function AuthedImage({ path, alt = "", className = "", onClick }) {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    let active = true;
    let objUrl;
    api.get(path, { responseType: "blob" })
      .then((r) => { if (!active) return; objUrl = URL.createObjectURL(r.data); setUrl(objUrl); })
      .catch(() => {});
    return () => { active = false; if (objUrl) URL.revokeObjectURL(objUrl); };
  }, [path]);
  if (!url) return <div className={`animate-pulse bg-slate-800 ${className}`} />;
  return <img src={url} alt={alt} onClick={onClick} className={className} />;
}
